<template> 
  <div class="router-front"></div>
  <div class="router">
  
  <router-view v-slot="{ Component, route }">
  <transition name="fade" mode="out-in">
    <component :is="Component" :key="route.path" />
  </transition>
</router-view>
  </div> 
  <div  class="router-backend"></div>
  </template>
  <script setup>
  import {reactive,provide,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
  import * as vueUse from "@vueuse/core";
  import Language from "@/hooks/language.js";
  import Router from "@/hooks/router.js";
  import bridge from "@/utils/sdkBridge.js";
  import * as request from "@/api/request";
  import * as utils from "@/utils";
  import * as _ from "lodash-es";
  import { useRoute } from 'vue-router';
 

 const route = useRoute();
      const { initLang ,curLang, getLangTxt, langData} = Language();

      const routerData = {};
      const compData = {};
      const PAGE_DATA_LANG = {"default":{"isLogin":true,"host":utils.getMainHost(),"pageId":"musqr01","loginAccount":"jiayaner","isBind":true,"serverName":"S1 超级厉害服","roleName":"超级厉害角色","signTime":2,"lotteryTime":3,"couponCount":50,"money":"250","infoPopupState":false,"bindPopupState":false,"bagPopupState":false,"myPackageList":[{award_time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"tipsPopupState":false,"propsPopupState":false,"curGiftPic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710074115524.png","quanPopupState":false,"tips":"提示语","serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"firstPayType":"sendVt","firstPayState":0,"gameId":390,"pageName":"精灵盛典欧美情人节赠礼","uid":``,"lotteryType":"no_reset","curGiftName":"一个神奇的大礼包","seeGiftPopupState":false,"seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"payEnough":false,"giftCodePopupState":false,"recentServerList":[],"quanUseLink":`https://www.37games.com`,"storeLink":`https://pay.37games.com/platform/officialWebStore.html?gameId=390`,"exchangeLink":`https://gevents.37games.com/globalexchange/index.html?gameId=390`,"common-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732022128655-83.png`,"lottery-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732022128681-99.png`,"isEdit":true,"canReBind":false},"en-US":{"isLogin":true,"host":utils.getMainHost(),"pageId":"musqr01","loginAccount":"jiayaner","isBind":true,"serverName":"S1 超级厉害服","roleName":"超级厉害角色","signTime":2,"lotteryTime":3,"couponCount":50,"money":"250","infoPopupState":false,"bindPopupState":false,"bagPopupState":false,"myPackageList":[{award_time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"tipsPopupState":false,"propsPopupState":false,"curGiftPic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710074115524.png","quanPopupState":false,"tips":"提示语","serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"firstPayType":"sendVt","firstPayState":0,"gameId":390,"pageName":"精灵盛典欧美情人节赠礼","uid":``,"lotteryType":"no_reset","curGiftName":"一个神奇的大礼包","seeGiftPopupState":false,"seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"payEnough":false,"giftCodePopupState":false,"recentServerList":[],"quanUseLink":`https://www.37games.com`,"storeLink":`https://pay.37games.com/platform/officialWebStore.html?gameId=390`,"exchangeLink":`https://gevents.37games.com/globalexchange/index.html?gameId=390`,"common-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732022128655-83.png`,"lottery-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732022128681-99.png`,"isEdit":true,"canReBind":false},"ru-RU":{"isLogin":true,"host":utils.getMainHost(),"pageId":"musqr01","loginAccount":"jiayaner","isBind":true,"serverName":"S1 超级厉害服","roleName":"超级厉害角色","signTime":2,"lotteryTime":3,"couponCount":50,"money":"250","infoPopupState":false,"bindPopupState":false,"bagPopupState":false,"myPackageList":[{award_time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"tipsPopupState":false,"propsPopupState":false,"curGiftPic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710074115524.png","quanPopupState":false,"tips":"提示语","serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"firstPayType":"sendVt","firstPayState":0,"gameId":390,"pageName":"精灵盛典欧美情人节赠礼","uid":``,"lotteryType":"no_reset","curGiftName":"一个神奇的大礼包","seeGiftPopupState":false,"seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"payEnough":false,"giftCodePopupState":false,"recentServerList":[],"quanUseLink":`https://www.37games.com`,"storeLink":`https://pay.37games.com/platform/officialWebStore.html?gameId=390`,"exchangeLink":`https://gevents.37games.com/globalexchange/index.html?gameId=390`,"common-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732022128655-83.png`,"lottery-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732022128681-99.png`,"isEdit":true,"canReBind":false},"pt-PT":{"isLogin":true,"host":utils.getMainHost(),"pageId":"musqr01","loginAccount":"jiayaner","isBind":true,"serverName":"S1 超级厉害服","roleName":"超级厉害角色","signTime":2,"lotteryTime":3,"couponCount":50,"money":"250","infoPopupState":false,"bindPopupState":false,"bagPopupState":false,"myPackageList":[{award_time:"2022-09-09 23:23:23",award_name:"一个奖励"}],"tipsPopupState":false,"propsPopupState":false,"curGiftPic":"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2022/12/16710074115524.png","quanPopupState":false,"tips":"提示语","serverList":[{sid:"",id:"",sname:"请选择伺服器"}],"roleList":[{roleID:"",roleName:"请选择角色"}],"serverItem":[{sid:"",id:"",sname:""}],"roleIndex":0,"firstPayType":"sendVt","firstPayState":0,"gameId":390,"pageName":"精灵盛典欧美情人节赠礼","uid":``,"lotteryType":"no_reset","curGiftName":"一个神奇的大礼包","seeGiftPopupState":false,"seeGift":[{name:"bbb",icon:"https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/03/16778242756836.png"}],"payEnough":false,"giftCodePopupState":false,"recentServerList":[],"quanUseLink":`https://www.37games.com`,"storeLink":`https://pay.37games.com/platform/officialWebStore.html?gameId=390`,"exchangeLink":`https://gevents.37games.com/globalexchange/index.html?gameId=390`,"common-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732022128655-83.png`,"lottery-btn-bg":`https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/11/1732022128681-99.png`,"isEdit":true,"canReBind":false}};
      const pageData = reactive(PAGE_DATA_LANG[curLang] || PAGE_DATA_LANG['en-US']||{});
      let pagePlatform = "global"
      let pagePlatformId = 8;

      provide("pageData", pageData);

      if(pageData.gameId!==void 0 ){
        pageData.gameId = utils.getUrlParams("gameId") ||  utils.getUrlParams("gameID") ||  utils.getUrlParams("game_id") || pageData.gameId || ""
      }

      initLang();
      // 自定义setup - 开始
      const router = Router()

// 如果是模版，就修改一个能用的活动标识
if (/^template/.test(pageData.pageId)) {
  pageData.pageId = "lotteryvn"
}

if (window.innerWidth < window.innerHeight && router.hasRoute("m")) {
  router.gotoRouter("/m")
}

window.activityDataLayer.push({
  eventName: "view_page",
  eventType: pageData.pageName,
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
// 记录礼包名
const giftInfo = reactive({
  firstPayAward: [],
  signInAward: [],
  lotteryAward: [],
  exchangeAward: [],
})

const curPlatform = pagePlatform;

const defaultServerItem = [
  {
    sid: "",
    id: "",
    sname: getLangTxt("pleaseSelectServer")
  },
]
const defaultRoleItem = [
  {
    roleID: "",
    roleName: getLangTxt("pleaseSelectRole")
  },
]

const listData = reactive({
  signList: [],
  mapList: [],
  lotteryList: [],
  exchangeList: [],
})

const canClickRefresh = ref(true)

const getCurLink = (link) => {
  let addParams = {
    gameId: pageData.gameId,
    scid: pageData.pageId,
    cid: "activity",
    language: curLang
  }
  return utils.updateLinkParams(link, addParams)
}

const resetData = () => {
  pageData.isEdit = false;
  pageData.isLogin = false
  pageData.loginAccount = ""
  pageData.isBind = false
  pageData.serverName = ""
  pageData.roleName = ""
  pageData.signTime = 0
  pageData.lotteryTime = 0
  pageData.couponCount = 0
  pageData.currency = ""
  pageData.money = ""
  pageData.infoPopupState = false
  pageData.bindPopupState = false
  pageData.bagPopupState = false
  pageData.tipsPopupState = false
  pageData.propsPopupState = false
  pageData.quanPopupState = false
  pageData.giftCodePopupState = false
  pageData.firstPayType = "sendVt"
  pageData.firstPayState = 0
  pageData.myPackageList = []
  pageData.curGiftPic = ""
  pageData.curGiftName = ""
  pageData.tips = ""
  pageData.serverList = []
  pageData.recentServerList = []
  pageData.roleList = _.cloneDeep(defaultRoleItem)
  pageData.selectServerIndex = 0
  pageData.selectRoleIndex = 0
  pageData.payEnough = false
  pageData.quanUseLink = getCurLink(pageData.quanUseLink);
  pageData.storeLink = utils.getStoreLinkWithCidScid({
    link: pageData.storeLink,
    paramsObj: {
      language: curLang,
      gameId: pageData.gameId,
    },
    pageId: pageData.pageId,
  });
  pageData.exchangeLink = getCurLink(pageData.exchangeLink);
}

const init = async () => {
  let loginState = await getUserJson()
  if (loginState) {
    window.activityDataLayer.push({
      eventName: "login",
      loginAccount: pageData.loginAccount,
      uid: pageData.uid,
      gameId: pageData.gameId,
      aid: pageData.pageId,
    })
  }
  initActivity()
}

const getUserJson = async () => {
  let res = await request.getJSON(utils.getUserJsonApi(pagePlatform))
  if (res.result == 1) {
    pageData.loginAccount = res.data.LOGIN_ACCOUNT
    pageData.isLogin = true
    pageData.uid = res.data.UID || res.data.USER_ID
  }
  return res && res.result == 1
}

const initActivity = async () => {
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'getConfig'), {
    params: JSON.stringify({
      language: curLang,
    }),
  })
  if (res.result == 1) {
    if (res.data.bind_data.role_id) {
      pageData.roleName = res.data.bind_data.role_name
      pageData.serverName = res.data.bind_data.server_name
      pageData.isBind = true
      try {
        window.__updatePointUploadCookie(
          "role_id",
          res.data.bind_data.role_id
        )
        window.__updatePointUploadCookie(
          "role_name",
          res.data.bind_data.role_name
        )
        window.__updatePointUploadCookie(
          "server_id",
          res.data.bind_data.server_id
        )
      } catch (error) {}
    }
    pageData.canReBind = !!+res.data?.switch_role
    pageData.lotteryTime = res.data.lottery_exchange_times
    pageData.couponCount = res.data.lottery_ticket
    pageData.lotteryType = res.data.lottery_type
    try {
      let _money = +res.data.pay_total_next_need
      pageData.payEnough = _money == 0
      pageData.money = `${_money.toLocaleString(curLang)}${
        res.data.area_currency
      }`
    } catch (error) {
      pageData.money = +res.data.pay_total_next_need + res.data.area_currency
    }
    pageData.signTime = res.data.sign_total
    pageData.firstPayType = res.data.first_pay.send_type
    pageData.firstPayState = res.data.first_pay.send_status
    listData.signList = res.data.sign_award_list
    listData.mapList = res.data.pay_total_list
    listData.lotteryList = res.data.lottery_list
    listData.exchangeList = res.data.exchange_list
  }
}

watch(
  async () => pageData.bagPopupState,
    (value) => {
      if (!value) return
      getPackageList()
    }
)

const getPackageList = async () => {
  pageData.myPackageList = []
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'listAward'), {
    params: JSON.stringify({
      language: curLang,
    }),
  })
  if (res.result == 1) {
    let curBagData = res.data?.reverse() || [];
    pageData.myPackageList.push(...curBagData)
  }
}

resetData()

const checkIsLogin = () => {
  if (pageData.isLogin) return true
  window.location.href = utils.getLoginUrlApi(pagePlatform, pageData.gameId)
  return false
}

const checkIsBind = () => {
  if (pageData.isBind) return true
  pageData.bindPopupState = true
  return false
}

const showTips = (txt, code) => {
  pageData.tips = `${txt} ${code ? `[${code}]` : ""}`
  pageData.tipsPopupState = true
}

const showGetSucc = (type, pic, name) => {
  if (type == "sendVt") {
    pageData.propsPopupState = true
  } else if (type == "sendSerial") {
    pageData.giftCodePopupState = true
  } else {
    pageData.quanPopupState = true
  }
  pageData.curGiftPic = pic
  pageData.curGiftName = name
}

provide("checkIsLogin", checkIsLogin)
provide("checkIsBind", checkIsBind)
provide("listData", listData)
provide("initActivity", initActivity)
provide("canClickRefresh", canClickRefresh)
provide("showTips", showTips)
provide("showGetSucc", showGetSucc)
provide("init", init)
provide("giftInfo", giftInfo)
provide("getCurLink", getCurLink)
      // 自定义setup - 结束


  </script>
  <style lang="scss">
    @import 'assets/common.scss';

    .btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
  </style>
  